import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class StorageService {

  constructor() { }

  public setItem(key: string, value: any): void
  {

    localStorage.setItem(key, JSON.stringify(value))

  }

  public getItem(key: string): any
  {

    const item = localStorage.getItem(key)

    return item ? JSON.parse(item) : null

  }

  public removeItem(key: string): void
  {

    localStorage.removeItem(key)

  }

  public clear(): void
  {

    localStorage.clear()

  }
}
